/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Count_LabelInputs */

const en_admin_invite_codes_count_label = /** @type {(inputs: Admin_Invite_Codes_Count_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many`)
};

const zh_admin_invite_codes_count_label = /** @type {(inputs: Admin_Invite_Codes_Count_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

/**
* | output |
* | --- |
* | "How many" |
*
* @param {Admin_Invite_Codes_Count_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_count_label = /** @type {((inputs?: Admin_Invite_Codes_Count_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Count_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_count_label(inputs)
	return zh_admin_invite_codes_count_label(inputs)
});
export { admin_invite_codes_count_label as "admin.invite_codes.count_label" }